export default { title: 'Registrieren / Anmelden, um Ihre Bestellhistorie anzuzeigen' };
